/* eslint-disable */
export const cloneDeep = obj => JSON.parse(JSON.stringify(obj));
